<script setup>
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { message, Modal } from 'ant-design-vue';
import { computed, createVNode, onMounted, ref } from 'vue';
import { useAdminStore } from '../../stores/admin';
const filterName = ref('')
const filterEmail = ref('')

const columns = [
  { title: '姓名', dataIndex: '姓名', key: '姓名' },
  { title: 'email', dataIndex: 'email', key: 'email'  },
  { title: '上架件數', dataIndex: '上架件數', key: '上架件數' },
  { title: '售出件數', key: '售出件數', dataIndex: '售出件數' },
  { title: '售出比例', key: '售出比例', slots: { customRender: 'saledPercent' },},
  { title: '水資源', key: '水資源', dataIndex: '水資源' },
  { title: '碳排放', key: '碳排放', dataIndex: '碳排放' },
  { title: '總水資源', key: '總水資源', dataIndex: '總水資源' },
  { title: '總碳排放', key: '總碳排放', dataIndex: '總碳排放'},
  { title: '衣櫥連結', key: '衣櫥連結', dataIndex: '衣櫥連結' },
  { title: '未上架資訊', key: '未上架資訊', dataIndex: '未上架資訊', slots: { customRender: 'onShelfInfo' }, },
  // { title: '推薦連結', key: '推薦連結', dataIndex: '推薦連結' },
  { title: '優惠代碼', key: '優惠代碼', dataIndex: '優惠代碼' },
  { title: '分享次數', key: 'shareClickCount', dataIndex: 'shareClickCount'},
  { title: '編輯', key: 'action', slots: { customRender: 'actionSlot' }}
];

const AdminStore = useAdminStore()
onMounted(() => {
  if (!AdminStore.userList.length) AdminStore.queryUser()
})

const handleClick = () => {
  if (filterName.value || filterEmail.value) AdminStore.queryUser([{ column: 'email', value: filterEmail.value }, { column: '姓名', value: filterName.value }])
  else AdminStore.queryUser()
}

const modalHasShow = ref(false)
const cleanPassword = ref('')
const toggleShowModal = bool => modalHasShow.value = bool
const cleanCollection = async () => {
  if(cleanPassword.value!=='刪除使用者資料庫中的全部資料') message.warning('輸入框中的刪除指令錯誤，請確認')
  else {
    const { state } = await AdminStore.cleanCollection('User')
    if (state === 'SUCCESS') message.success('已成功清空資料庫')
  }
}

const editRow = ref(null)
const editModalHasShow = computed(() => Boolean(editRow.value))
const edit = email => editRow.value = JSON.parse(JSON.stringify(AdminStore.userList[AdminStore.userList.map(e => e.email).indexOf(email)]))
const handleSubmit = async () => {
  const result = await AdminStore.updateData({ collectionName: 'User', data: { ...editRow.value }})
  console.log(result)
  if (result.state === 'SUCCESS') {
    editRow.value = null
    message.success('已成功修改資料')
  }
}
const handleCancel = () => editRow.value = null
const handleDelete = key => {
  Modal.confirm({
    title: () => '確定要刪除此資料？',
    icon: () => createVNode(ExclamationCircleOutlined),
    cancelText: () => '取消',
    okText: () => '刪除',
    onOk() {
      return new Promise((resolve) => {
        AdminStore.deleteData({ collectionName: 'User', dataKey: key }).then(() => {
          resolve()
          message.success('已成功刪除資料')
        })
      })
    },
    onCancel() {},
  })
}
</script>

<template>
  <div class="view-admin-dashboard">
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240)"
      title="使用者資料"
      sub-title="使用者基本資料"
    >
      <!-- <template #extra>
        <a-button type="primary" danger @click="toggleShowModal(true)">清空資料庫</a-button>
      </template> -->
    </a-page-header>

    <a-card title="以條件搜尋使用者">
      <a-input v-model:value="filterName">
        <template #addonBefore>
          名稱
        </template>
      </a-input>
      <a-input v-model:value="filterEmail">
        <template #addonBefore>
          Email
        </template>
      </a-input>
      <a-button type="primary" @click="handleClick">搜尋</a-button>
    </a-card>

    <a-table v-if="AdminStore.userList?.length" :columns="columns" :data-source="AdminStore.userList" :scroll="{ x: 1000 }">
      <template #saledPercent="{ record }">
        <span>{{ `${Math.round(parseInt(record['售出件數']) / parseInt(record['上架件數'])*100 * 10) / 10}%` }}</span>
      </template>
      <template #actionSlot="{ record }">
        <div>
          <a @click="edit(record.email)">修改</a>
          <br>
          <a class="delete-button" @click="handleDelete(record.key)">刪除</a>
        </div>
      </template>
    </a-table>

    <a-empty v-else></a-empty>

    <a-modal class="dashboard-modal" v-model:visible="modalHasShow" title="選擇要存入的資料庫" :footer="null">
      <h3>確定要清空資料庫？</h3>
      <span>如要清空資料庫，請於下方輸入框中輸入「刪除使用者資料庫中的全部資料」</span>
      <a-input v-model:value="cleanPassword" placeholder="enter..."></a-input>
      <div>
        <a-button type="primary" @click="toggleShowModal(false)">取消</a-button>
        <a-button type="primary" danger @click="cleanCollection">刪除</a-button>
      </div>
    </a-modal>

    <a-modal class="dashboard-edit-modal" :closable="false" v-model:visible="editModalHasShow" title="修改使用者資料" :footer="null">
      <a-form v-if="editRow" :modol="editRow">
        <a-form-item v-for="column in columns.filter(c => c.dataIndex)" :key="column.dataIndex" :label="column.dataIndex">
          <a-input v-model:value="editRow[column.dataIndex]" />
        </a-form-item>
        <a-form-item class="btn-group">
          <a-button style="margin-right: 10px" @click="handleCancel">取消</a-button>
          <a-button type="primary" @click="handleSubmit">修改</a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
